import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';

import { ta, adminLocale } from '../../i18n/adminT';
const emptyForm = { username: '', email: '', role: 'admin', password: '' }; // role: admin | super_admin | supervisor | operator

function roleLabel(a) {
  if (a.is_supervisor) return ta('Supervisor');
  if (a.is_operator) return ta('Operatore');
  if (a.is_super_admin) return ta('Super-admin');
  return ta('Admin');
}

export default function AdminsManager() {
  const [admins, setAdmins] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState('');
  const [creating, setCreating] = useState(false);
  const [newTempPassword, setNewTempPassword] = useState(null);

  const load = async () => {
    const res = await api.getAdmins();
    setAdmins(res.data);
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    setError('');
    setNewTempPassword(null);
    if (!form.username.trim() || !form.email.trim()) {
      setError(ta('Username ed email sono obbligatori.'));
      return;
    }
    setCreating(true);
    try {
      const payload = {
        username: form.username,
        email: form.email,
        isSuperAdmin: form.role === 'super_admin',
        isSupervisor: form.role === 'supervisor',
        isOperator: form.role === 'operator',
        password: form.password.trim() || undefined,
      };
      const res = await api.createAdmin(payload);
      setNewTempPassword({ username: form.username, password: res.tempPassword, emailSent: res.emailSent });
      setForm(emptyForm);
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setCreating(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm(ta('Eliminare questo account?'))) return;
    try {
      await api.deleteAdmin(id);
      await load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <h1 className="admin-page-title">{ta('Amministratori')}</h1>
      <p className="admin-page-subtitle">{ta('Gestisci gli account con accesso al pannello di amministrazione.')}</p>

      {error && <div className="form-error">{error}</div>}

      <div className="admin-card">
        <table className="admin-table">
          <thead>
            <tr>
              <th>{ta('Username')}</th>
              <th>{ta('Email')}</th>
              <th>{ta('Ruolo')}</th>
              <th>{ta('2FA')}</th>
              <th>{ta('Ultimo accesso')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {admins.map((a) => (
              <tr key={a.id}>
                <td>{a.username}</td>
                <td>{a.email}</td>
                <td>{roleLabel(a)}</td>
                <td>
                  {a.is_supervisor
                    ? <span style={{ color: 'var(--muted-text)' }}>{ta('Non usata')}</span>
                    : <span className={`badge-pill badge-pill--${a.totp_enabled ? 'yes' : 'no'}`}>{a.totp_enabled ? ta('Attiva') : ta('Non attiva')}</span>}
                </td>
                <td className="mono">{a.last_login_at ? new Date(a.last_login_at).toLocaleString(adminLocale()) : '—'}</td>
                <td><button className="btn-ghost btn" style={{ width: 'auto', padding: '6px 10px' }} onClick={() => handleDelete(a.id)}>{ta('Elimina')}</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="admin-card" style={{ maxWidth: 420 }}>
        <h3 style={{ marginBottom: 14 }}>{ta('Nuovo account')}</h3>
        <form onSubmit={handleCreate}>
          <div className="field">
            <label>{ta('Username')}</label>
            <input type="text" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} />
          </div>
          <div className="field">
            <label>{ta('Email')}</label>
            <input type="text" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className="field">
            <label>{ta('Ruolo')}</label>
            <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
              <option value="admin">{ta('Amministratore')}</option>
              <option value="super_admin">{ta('Super-amministratore')}</option>
              <option value="supervisor">{ta('Supervisor (solo reset 2FA altrui, niente 2FA propria)')}</option>
              <option value="operator">{ta('Operatore (solo utenti esterni, referenti, chiusura ingressi — sessione senza scadenza)')}</option>
            </select>
          </div>
          <div className="field">
            <label>{ta('Password')} <span className="optional-tag">{ta('(facoltativa)')}</span></label>
            <input type="text" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} autoComplete="off" placeholder={ta('Lascia vuoto per generarne una casuale')} />
            <span className="field-hint">{ta('Utile se ti serve consegnarla subito, senza aspettare o accedere alla casella email del nuovo account. Minimo 8 caratteri.')}</span>
          </div>
          <button className="btn btn-primary" disabled={creating}>{creating ? ta('Creazione…') : ta('Crea account')}</button>
        </form>

        {newTempPassword && (
          <div className="temp-password-box">
            {newTempPassword.emailSent && (
              <>{ta('✔ Email con le credenziali inviata a')} <strong>{newTempPassword.username}</strong>.<br /><br /></>
            )}
            {!newTempPassword.emailSent && (
              <>{ta('⚠ Email non inviata (controlla le Impostazioni SMTP).')}<br /><br /></>
            )}
            {ta('Password di')} <strong>{newTempPassword.username}</strong>:<br />
            {newTempPassword.password}
            <br /><br />
            {ta('La verifica in due passaggi è facoltativa (tranne che per i supervisor, che non la usano): potrà attivarla da "Il mio account" quando vuole. Questa password non verrà mostrata di nuovo.')}
          </div>
        )}
      </div>
    </div>
  );
}
